/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import account from "./modules/account";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import SecureLS from "secure-ls";

Vue.use(Vuex);

const secureStorage = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "LifeMustGoOn",
});

const accountState = createPersistedState({
  key: "account-state-persist",
  paths: [
    "account.nama",
    "account.id",
    "account.email",
    "account.role",
    "account.prodi",
    "account.employee",
    "account.userAccess",
    "account.currentPeriod",
  ],
  storage: {
    getItem: (key) => secureStorage.get(key),
    setItem: (key, value) => secureStorage.set(key, value),
    removeItem: (key) => secureStorage.remove(key),
  },
});

export default new Vuex.Store({
  modules: {
    account,
  },

  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== "production",
  plugins: [accountState],
});
